import React, { useEffect } from 'react';

const Product4 = () => {
  useEffect(() => {
    // Scroll to the top of the page when the component is mounted
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="p-10 bg-black text-white">
      {/* Company Name at the Top */}

      
      

      <div className="space-y-12">

        {/* Company Overview Section */}
        <section className="flex flex-col lg:flex-row items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src="https://sigmavision.in/images/flange-counting-manual-inspection-system1.jpg"
              alt="Company Overview"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">

          <h1 className="text-4xl font-bold text-center mb-6 text-transparent bg-clip-text bg-gradient-to-r from-white to-white animate-slide-in">
      SigmaVision and Robotics
      </h1><br></br>

            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
              Company Overview
            </h3>
            <p className="text-lg leading-relaxed transition duration-500 ease-in-out transform hover:scale-105 hover:text-gray-200">
              SigmaVision and Robotics specializes in designing, manufacturing, supplying, and installing robotics-based application solutions
              and camera-based vision inspection machines, tailored to meet the specific requirements of our customers. In addition, we provide
              automation solutions and consultancy services. We also handle the up-gradation, re-conditioning, and servicing of existing robotics
              and camera-based inspection machines, as well as provide spares and replacement parts.
            </p>
          </div>
        </section>

        {/* Application Industries Section */}
        <section className="text-center">
          <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
            Industries We Serve
          </h3>
          <ul className="list-disc list-inside text-lg space-y-4 transition-all duration-300 hover:text-gray-300">
            <li><strong>Food & Beverages:</strong> Robotics & vision-based solutions for processing and packaging</li>
            <li><strong>Pharmaceutical Industry:</strong> Inspection and packaging automation</li>
            <li><strong>Lube Oil Sector:</strong> Quality control and packaging automation</li>
            <li><strong>Metal Industry:</strong> Precision inspection systems for metal products</li>
            <li><strong>Plastic/Glass Bottles Manufacturing:</strong> Vision inspection systems for production lines</li>
            <li><strong>Printing & Converting Industries:</strong> Automation solutions for printing and packaging</li>
            <li><strong>Moulding and Forging Machines:</strong> Robotics solutions for production lines</li>
            <li><strong>Packaging Lines:</strong> Automation for various product packaging</li>
            <li><strong>Agriculture Products / Drip Line Irrigation System:</strong> Automation for agriculture processes</li>
          </ul>
        </section>

        {/* Service Offerings Section */}
        <section className="flex flex-col lg:flex-row-reverse items-center lg:space-x-8">
          <div className="lg:w-1/2 mb-6 lg:mb-0">
            <img
              src="https://sigmavision.in/images/Metal-Sheet-Surface-Monitoring.jpg"
              alt="Service Offerings"
              className="rounded-lg shadow-xl transform transition-transform duration-500 hover:scale-105"
            />
          </div>
          <div className="lg:w-1/2">
            <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
              Our Services
            </h3>
            <p className="text-lg leading-relaxed transition duration-500 ease-in-out transform hover:scale-105 hover:text-gray-200">
              We specialize in providing automation solutions and consultancy, offering a full range of services including design, manufacturing,
              supply, installation, and commissioning of robotics-based applications and camera-based vision inspection machines. Additionally,
              we undertake the up-gradation and re-conditioning of existing systems and provide spare parts and change parts for inspection machines.
            </p>
          </div>
        </section>

        {/* Contact Us Section */}
        <section className="mt-12 text-center">
          <h3 className="text-3xl font-semibold mb-3 text-transparent bg-clip-text bg-gradient-to-r from-white to-black">
            Contact Us
          </h3>
          <p className="text-lg">
            For more information about our products and services, please contact us at:- 
            <a href="mailto:rambomble@alphaq.co.in" className="text-blue-500 hover:text-blue-700 transition-colors duration-300">
            rambomble@alphaq.co.in
            </a>
          </p>
        </section>

      </div>
    </div>
  );
};

export default Product4;
